import { profileTh } from "@/module/Profile/locale/ProfileLocaleTh.js";
import { register } from "@/module/Register/locale/register.th.js";
import { pdpa } from '@/module/Static/locale/Pdpa/pdpa.th.js'
import { login } from '@/module/Login/locale/login.th';

import { changePassword } from '@/module/ChangePassword/Locale/changePasswordLocaleTh.js'
import { myprofile } from "@/module/MyProfile/locale/myprofile.th";
import { searchList } from "@/module/SearchList/locale/SearchListLocaleTh.js";
import { contactUS } from "@/module/ContactUs/Locale/contactUs.th";
import { language } from "@/module/LanguagePage/Locale/language.th";
import { privacySetting } from "@/module/PrivacySetting/Locale/privacySetting.th";

export const th = {
    default: {
        search: 'ค้นหา',
        confirm: 'ยืนยัน',
        ok: 'ตกลง',
        cancel: 'ยกเลิก',
        close: 'ปิด',
        submit: 'ตกลง',
    },

    my_account: 'MY ACCOUNT',
    profile: profileTh,
    register: register,
    pdpa: pdpa,
    login: login,
    changePassword: changePassword,
    myprofile: myprofile,
    searchList: searchList,
    contactUS: contactUS,
    language: language,
    privacySetting: privacySetting,
    date: {
        days: 'วัน',
        months: 'เดือน',
        years: 'ปี',
        minutes: 'นาที',
        minutes_short: 'น.',
        hours: 'ชั่วโมง',
        hours_short: 'ช.ม.',
        date_flase: 'กรุณาระบุวันเกิด',
        month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }]
    },
    confirm_redeem: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        headline: 'ยืนยัน',
        default: 'ยืนยันการรับสิทธิ์',
        defualt_have_time: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันการรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันการรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
    },
    redeem_button: {
        default: 'กดรับสิทธิ์',
        none: '',
        soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        soldOutBuy: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        maxPerPerson: 'ขออภัย คุณได้แลกรับสิทธิ์นี้แล้ว',
        redeemCoolDown: 'ขออภัย คุณได้รับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
        campaignExpired: 'สินค้านี้หมดอายุแล้ว',
        campaignExpiredBuy: 'สินค้านี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนของคุณไม่เพียงพอที่จะแลกรับสิทธิ์',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้'
    },
    purchase: {
        show_code: 'กดเพื่อดูรหัส',
        code_expired: 'รหัสหมดอายุ',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
        shipped: 'สินค้าได้ถูกจัดส่งเรียบร้อยแล้ว',
        parcel_no: 'พัสดุเลขที่',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
    },
    serial: {
        close_btn: 'ปิด',
        default_privilege_message: 'ตามดีไซน์',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'โค้ด',

        copy_code: 'คัดลอก',

        expire_in: 'หมดเวลาใน ',
        code_expired: 'รหัสหมดอายุ',

        redeem_on: 'รับสิทธิ์เมื่อ {0}'
    },
    shipping: {
        headline: 'ที่อยู่จัดส่ง',

        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        addressName: {
            name: 'ชื่อที่อยู่',
            placeholder: 'ชื่อที่อยู่',
            required: 'กรุณากรอกชื่อที่อยู่',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'แขวง/ตำบล',
            placeholder: 'กรุณาเลือกแขวง/ตำบล',
            required: 'กรุณาเลือกแขวง/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'เขต/อำเภอ',
            placeholder: 'กรุณาเลือกเขต/อำเภอ',
            required: 'กรุณาเลือกเขต/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',
    },
    tax: {
        personType: {
            name: 'ออกในนาม',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        title: {
            name: 'คำนำหน้าชื่อ',
            placeholder: '',
            required: 'กรุณาเลือก',
            too_short: '',
            invalid: '',
        },
        companyName: {
            name: 'ชื่อ / บริษัท',
            placeholder: 'ชื่อ / บริษัท',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'อาคาร',
            placeholder: 'อาคาร',
            required: '',
            too_short: '',
            invalid: '',
        },
        room: {
            name: 'เลขที่ห้อง',
            placeholder: 'เลขที่ห้อง',
            required: '',
            too_short: '',
            invalid: '',
        },
        floor: {
            name: 'ชั้นที่',
            placeholder: 'ชั้นที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        village: {
            name: 'หมู่บ้าน',
            placeholder: 'หมู่บ้าน',
            required: '',
            too_short: '',
            invalid: '',
        },
        number: {
            name: 'เลขที่',
            placeholder: 'เลขที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        moo: {
            name: 'หมู่ที่',
            placeholder: 'หมู่ที่',
            required: '',
            too_short: '',
            invalid: '',
        },
        soi: {
            name: 'ซอย',
            placeholder: 'ซอย',
            required: '',
            too_short: '',
            invalid: '',
        },
        road: {
            name: 'ถนน',
            placeholder: 'ถนน',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        terms: "Terms And Conditions",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
    },
    campaign: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
    },
    detail: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',

        point_unit: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        available_date: 'แลกได้วันที่',
        expire_date: 'วันหมดอายุ : {0}',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },
        select: 'ตัวเลือก :',

        amount: 'จำนวน',
        add_cart: 'เพิ่มในตะกร้า',
        buy_now: 'ซื้อเลย',
        distributed_by: 'จัดจำหน่ายโดย',
        delivery_to: 'จัดส่งที่',
        edit_address: 'แก้ไขที่อยู่',
        free: 'ฟรี',
        also_like: 'คุณอาจสนใจ',
        share: 'แชร์',
        page_link: 'ลิ้งค์',
        copy: 'คัดลอก',
        copied: 'คัดลอกแล้ว'
    },
    history: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',

        parcel_number: 'เลขพัสดุ : ',
    },
    error_code: {
        code_412: 'token ไม่ถูกต้อง',
        code_campaignId: 'campaign id ไม่ถูกต้อง',
        code_cat_id: 'category id ไม่ถูกต้อง',
        code_agency_id: 'agency id ไม่ถูกต้อง',
        code_target_page: 'target page ไม่ถูกต้อง'
    },
    otp: {
        otp_code: 'รหัสผ่านใช้ครั้งเดียว (OTP)',
        otp_phone: 'รหัสผ่านใช้ครั้งเดียว (OTP) ส่งไปที่เบอร์',
        refcode: 'รหัสอ้างอิง',
        plz_input_otp: '',
        minute: '',
        resend_otp: 'ส่ง OTP อีกครั้ง',
        time_remain: 'รหัสจะหมดอายุภายใน',
        err_otp: 'รหัสไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
        err_code: 'Error Code :',
        btn_ok: 'ยืนยัน',
        btn_cancel: 'ยกเลิก'
    },
    topbar: {
        label: {
            signup: 'ลงทะเบียน',
            login: 'เข้าสู่ระบบ',
        },
        dont_have_account: 'ยังไม่มีบัญชีเข้าใช้งาน?',
        login: 'เข้าสู่ระบบ',
        register: 'ลงทะเบียน',
        search: {
            placeholder: 'ค้นหา...',
            topSearch: 'ค้นหายอดนิยม'
        }
    },
    footer: {
        fast_delivery: 'จัดส่งด่วนภายในประเทศ',
        tracking: 'ติดตามสถานะการจัดส่ง<br>ได้ทุกขั้นตอน',
        safe_payment: 'ชำระเงินอย่างปลอดภัย',
        warranty: 'รับประกันสินค้าของแท้',
        payment_method: 'ช่องทางการชำระเงิน',
        delivery_service: 'ช่องทางการจัดส่ง',
        power_by:'ดำเนินการโดย',
        shopdd: {
            title: 'ช้อปดีดี',
            contact: 'ติดต่อเรา',
            tracking: 'ติดตามสินค้า',
            faq: 'คำถามที่พบบ่อย',
            news: 'ข่าวสารและกิจกรรม',
        },
        policy: {
            title: 'นโยบาย',
            condition: 'เงื่อนไขการใช้งาน',
            privacy: 'นโยบายความเป็นส่วนตัว',
            cookie: 'นโยบายการใช้คุกกี้',
        },
        customer: {
            title: 'ลูกค้าสัมพันธ์',
            office_hour: 'จันทร์-อาทิตย์ เวลา 09.00 - 17.30 ยกเว้นวันหยุดนักขัตฤกษ์',
            tel: 'โทร : 02-760-3988',
            email_label: 'อีเมลล์ : ',
            email: 'support@buzzebees.com',
            market_copyright: '© B2B Marketplace 2023',
        },
        shop_detail: '<p>B2B Marketplace แพลตฟอร์มอีคอมเมิร์ซชั้นนำ มีพันธกิจหลักในการผสานจุดแข็ง ส่งมอบสินค้าและบริการที่ตอบโจทย์ทุกความต้องการผ่านเทคโนโลยีอันทันสมัย ไม่ว่าจะเป็นการใช้บิ๊กดาต้า เทคโนโลยีปัญญาประดิษฐ์ (Artificial Intelligence) หรือเครื่องจักรอัตโนมัติ เพื่อสร้างประสบการณ์ช้อปปิ้งออนไลน์ที่ดีที่สุดให้กับลูกค้า </p><p>B2B Marketplace มุ่งเน้นสร้างความมั่นใจให้กับลูกค้าในทุกมิติที่เกี่ยวกับการช้อปปิ้ง ซึ่งให้ความสำคัญตั้งแต่เรื่องของการการันตีสินค้าคุณภาพของแท้ 100% จากแบรนด์ในประเทศและต่างประเทศ บริการจัดส่งสินค้ารวดเร็วและมีประสิทธิภาพ ตลอดจนมีเจ้าหน้าที่คอยบริการก่อนและหลังการขาย อีกทั้งยังอำนวยความสะดวกให้ลูกค้าช้อปสินค้าราคาโดนใจได้ทุกที่ทุกเวลา โดยทั้งหมดนี้เพื่อมุ่งเป้าสู่การเป็นแบรนด์อีคอมเมิร์ซอันดับ 1 ที่ได้รับความไว้วางใจจากผู้บริโภคมากที่สุด นอกจากนี้ B2B Marketplace ยังมีเป้าหมายที่จะเป็นฟันเฟืองสำคัญในการเสริมสร้างความสามารถในการแข่งขันของเอสเอ็มอีไทยในตลาดโลก และเป็นส่วนหนึ่งในการยกระดับโครงสร้างระบบโลจิสติกส์ไทยให้ทัดเทียมระดับมาตรฐานโลก เพื่อส่งเสริมให้ประเทศไทยเป็นศูนย์กลางธุรกิจอีคอมเมิร์ซในภูมิภาคเอเชียตะวันออกเฉียงใต้ในอนาคตอันใกล้ </p>',
        copyright: '© Copyright 2023 BUZZEBEES. All Rights Reserved',
    },
    btn_back: 'ย้อนกลับ',
    B2B: {
        home: {
            ends_in: "จบใน",
            see_more: "ดูทั้งหมด",
            brand: "ร้านค้า",
            category: "หมวดหมู่"
        },
        search: {
            placeholder: "ค้นหา",
            cancel: "ยกเลิก",
        },
        campaign: {
            point: "{0} คะแนน",
            price: "฿ {0}",
            detail: "รายละเอียด",
            condition: "เงื่อนไขการใช้งาน",
            add_to_cart: "ใส่ตะกร้า",
            item_added: "เพิ่มสินค้าในตะกร้าสำเร็จ",
        },
        flashsale: {
            item_count_sold: "ขายแล้ว {0} ชิ้น",
            buy_now: "ซื้อเลย",
            expire: "ขออภัย แคมเปญนี้ได้สิ้นสุดระยะเวลาแล้ว",
            close: "ปิด"
        }
    },
    forgetpassword: {
        forgetpassword: 'ลืมรหัสผ่าน',
        mobileNumber: {
            name: 'เบอร์โทรศัพท์มือถือ (ที่ลงทะเบียน)',
            placeholder: '',
            required: 'กรุณากรอก เบอร์โทรศัพท์มือถือ',
            too_short: '',
            invalid: 'format mobile number invalid',
        },
        err_nodata: 'ไม่พบหมายเลขโทรศัพท์ของคุณ กรุณาตรวจสอบอีกครั้ง'
    },
    side_menu : {
        profile: 'ข้อมูลส่วนตัว',
        changePassword: 'เปลี่ยนรหัสผ่านใหม่',
        my_wishlist: 'สิ่งที่อยากได้ของฉัน ({0})',
        my_order: 'ออเดอร์ของฉัน',
        contact_us: 'ติดต่อเรา',
        fag: 'คำถามที่ถามบ่อย',
        language: 'เปลี่ยนภาษา',
        privacy_setting: 'การจัดการข้อมูลส่วนบุคคล',
        terms_conditions: 'ข้อกำหนดและเงื่อนไข',
        privacy_policy: 'คำชี้แจ้งส่วนบุคคล',
        marketing_message: 'ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ทางการตลาด',
        unconsent: 'ยกเลิกการเป็นสมาชิก',
        logout: 'ออกจากระบบ'
    },
    unconsent_popup: {
        title: 'ยกเลิกสมาชิก!',
        msg: 'หากต้องการยกเลิกการเป็นสมาชิก กรุณาติดต่อลูกค้าสัมพันธ์ (Call Center) ทุกวัน เวลา 9.00 - 17.30 น.',
        tel: '02-760-3988'
    },
    logout_popup: {
        title: 'ออกจากระบบ',
        msg: 'คุนยืนยันออกจากระบบใช่หรือไม่',
        btnCancel: 'ยกเลิก',
        btnOk: 'ยืนยัน'
    },
    home: {
        flashsale_end: 'สิ้นสุดใน',
        seemore: 'ดูเพิ่มเติม',
        buy_again: 'ซื้ออีกครั้ง',
        voucher: 'โค้ดส่วนลดจาก ShopDD',
        condition: 'เงื่อนไข',
        get_code: 'เก็บโค้ด',
        brand: 'แบรน์',
        category: 'หมวดหมู่',
        my_wishlist: 'MY WISHLIST'
    },
    search: {
        search: 'ค้นหา',
        pop_search: 'คำค้นหายอดนิยม',
    },
    err_network: 'พบปัญหาการเชื่อมต่อ กรูณาตรวจสอบสัญญาณเครือข่าย',
    page: {
        home: 'หน้าหลัก',
        search: 'ค้นหา'
    },
    alert_popup: {
        login: {
            title: 'เข้าสู่ระบบ',
            msg: 'กรุณาล็อกอินเข้าสู่ระบบ',
            btnOk: 'เข้าสู่ระบบ',
            btnCancel: 'ยกเลิก'
        }
    }
};
